<template>
  <div class="index" v-loading="loading2"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="white_logo_line"></div>
        <div class="search">
          <input type="text" ref="ethaddres" placeholder="请输入以太坊钱包地址" />
          <a v-if="buttonStatus" @click="cxStart"></a>
          <a v-if="!buttonStatus" style="background-image: url('/static/no_search_button.png')"></a>
        </div>
        <div class="bottom_button">
            <img v-show="!!userIcon"  v-bind:src="userIcon === '' ? '/static/default_avatar.png' : userIcon" @click="goUserInfo" >
            <div v-if="!vipStatus" >
              <p>{{freeNumber}}<span>次</span></p>
              <span>剩余免费查询</span>
            </div>
            <div v-if="vipStatus" >
              <p>{{vipDays}}<span>天</span></p>
              <span>vip有效期</span>
            </div>
            <a @click="getMroe" >获得更多</a>
        </div>
        <div class="getMroe" v-if="popoverStatus" >
                <div class="popover">
                    <div class="top" v-if="!vipStatus">
                        <a @click="share">
                          赠送好友可多获一次机会
                        </a>
                        <a style="border-top: 0.013rem solid rgba(0,0,80,0.85);" @click="goPay('kt')" >
                          开通VIP会员
                        </a>
                    </div>
                    <div class="top" v-if="vipStatus" >
                      <a>
                        赠送好友可多获一次机会
                      </a>
                      <a style="border-top: 0.013rem solid rgba(0,0,80,0.85);"  @click="goPay('xf')">
                        VIP会员续费
                      </a>
                    </div>
                    <div class="bottom">
                      <a style="border-top: 0.013rem solid rgba(0,0,80,0.85);" @click="quit">
                        取消
                      </a>
                    </div>
                </div>
        </div>
    <div class="successTip" v-if="TipStutas">
      {{TipStutasText}}
    </div>
    <div class="shareTip" v-if="shareStutas" @click="quitShare"></div>
  </div>
</template>

<script>
import Config from '../config/index'
import callApi from '../../static/callApi'
import moment from 'moment'

export default {
  name: 'index',
  data () {
    return {
      vipStatus: false,
      popoverStatus: false,
      TipStutas: false,
      TipStutasText: '',
      freeNumber: '',
      userIcon: '/static/default_avatar.png',
      vipDays: '',
      buttonStatus: true,
      loading2: false,
      shareStutas: false
    }
  },
  created: function () {
    this.cxUserInfo()
  },
  methods: {
    getMroe: function () {
      this.popoverStatus = true
    },
    quit: function () {
      this.popoverStatus = false
    },
    openmessage: function (msg) {
      let _this = this
      this.TipStutasText = msg
      this.TipStutas = true
      setTimeout(function () {
        _this.TipStutasText = ''
        _this.TipStutas = false
      }, 2000)
    },
    cxUserInfo: function () {
      let _this = this
      callApi({
        method: 'get',
        url: Config.path + '/fbeeapi/asset/getassetuser',
        headers: {versioncode: 1.0, platform: 'smallprogram'}
      }, (response) => {
        _this.userIcon = String(response.data.content.assetUser.userIcon)
        localStorage.setItem('invCode', response.data.content.assetUser.invitation)
        if (response.data.content.assetUser.membersNumber === 0) {
          _this.freeNumber = response.data.content.assetUser.freeNumber
          if (Number(_this.freeNumber) <= 0) {
            _this.buttonStatus = false
          }
          _this.vipStatus = false
        } else {
          var a = moment(response.data.content.assetUser.membersNumber)
          var b = moment(response.data.content.assetUser.openDate)
          _this.vipDays = Number(a.diff(b, 'day', true)).toFixed(0)
          _this.vipStatus = true
        }
      }, this)
    },
    cxStart: function () {
      let ethaddres = this.$refs.ethaddres.value
      if (ethaddres.indexOf('0x') !== 0 || ethaddres.length !== 42) {
        this.openmessage('请输入正确的以太坊地址')
      } else {
        this.asstsQueryNow()
      }
    },
    asstsQueryNow: function () {
      this.loading2 = true
      let _this = this
      callApi({
        method: 'get',
        url: Config.path + '/fbeeapi/asset/query',
        headers: {uuid: this.uuid, versioncode: 1.0, platform: 'smallprogram'},
        params: {address: this.$refs.ethaddres.value, uid: localStorage.getItem('uid')}
      }, (response) => {
        if (response.data.success === '1') {
          _this.loading2 = false
          _this.$router.push({path: '/asstsQuery', query: {cxAsstsId: response.data.content, urlly: 'cx'}})
        } else {
          _this.openmessage(response.data.message)
          _this.loading2 = false
        }
      }, this)
    },
    goUserInfo: function () {
      this.$router.push({path: '/userInfo'})
    },
    goPay: function (zt) {
      this.$router.push({path: '/fbeePay', query: {zt: zt}})
    },
    share: function () {
      this.shareStutas = true
      this.popoverStatus = false
    },
    quitShare: function () {
      this.shareStutas = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  input::-webkit-input-placeholder{
    color:#C6C5CC;
    font-size: 0.427rem;
    line-height: 0.533rem;
  }
  input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color:#C6C5CC;
    font-size: 0.427rem;
    line-height: 0.533rem;
  }
  input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color:#C6C5CC;
    font-size: 0.427rem;
    line-height: 0.533rem;
  }
  input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color:#C6C5CC;
    font-size: 0.427rem;
    line-height: 0.533rem;
  }
  .index{
    background-image: url("/static/background1.png");
    width: 100%;
    height: inherit;
    background-size: 100% auto;
    /*background-position: 0 -2.268rem;*/
    background-position: 0;
    background-repeat: no-repeat;
  }
  .white_logo_line{
    width: 2.36rem;
    height: 2.0667rem;
    background-image: url("/static/logo_line_white.png");
    background-size: 100%;
    position: absolute;
    left: 3.973rem;
    top: 2.0667rem;
  }
  .search{
    width: 8.267rem;
    height: 1.6rem;
    position: relative;
    top: 5.747rem;
    transform: translateX(-50%);
    left: 50%;
  }
  .search input{
    width: 6.64rem;
    height: 100%;
    font-family: PingFangSC-Regular;
    background: #F9F8FC;
    border-radius: 1.333rem;
    outline: none;
    border: none;
    text-indent: 0.533rem;
    background-color: #F9F8FC;
    color:#229FFF;
    font-size: 0.533rem;
    padding-right: 1.627rem;
  }
  .search a{
    width: 1.333rem;
    height: 1.333rem;
    background-image: url("/static/search_button.png");
    background-size: 100% 100%;
    position: absolute;
    right: 0.1333333rem;
    top: 0.133333333rem;
  }
  .bottom_button{
    width: 7.867rem;
    height: 1.933rem;
    position: absolute;
    left: 1.333rem;
    top: calc(100vh - 1.933rem - 1.867rem);
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
  }
  .bottom_button img{
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 100%;
    border: 0.05rem solid #fff;
  }
  .bottom_button div{
    margin-left: 0.533rem;
  }
  .bottom_button div p{
    font-family: PingFangSC-Regular;
    font-size: 1.2rem;
    color: #FFFFFF;
    line-height: 1rem;
  }
  .bottom_button div p span{
    font-family: PingFangSC-Medium;
    font-size: 0.32rem;
    color: #FFFFFF;
  }
  .bottom_button div>span{
    opacity: 0.5;
    font-family: PingFangSC-Medium;
    font-size: 0.32rem;
    color: #FFFFFF;
    line-height: 0.32rem;
  }
  .bottom_button a{
    background-image: linear-gradient(-165deg, #FCEF22 0%, #FFDA28 100%);
    border-radius: 1.333rem;
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #744A05;
    text-align: center;
    display: block;
    width: 2.933rem;
    height: 1.333rem;
    line-height: 1.333rem;
    position: absolute;
    right: 0;
  }
  .getMroe{
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(0,0,0,0.7);
    top: 0;
    left: 0;
    z-index: 10;
  }
  .getMroe .popover{
    position: absolute;
    width: 9.467rem;
    height: 4.8rem;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0.9333rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .getMroe .popover .top{
    background: rgba(248,248,248,0.82);
    border-radius: 0.373rem;
    height: 3.053rem;
    width: 100%;
    overflow: hidden;
  }
  .getMroe .popover .top a{
    width: 100%;
    height: 1.52rem;
    font-family: PingFangSC-Medium;
    font-size: 0.533rem;
    color: #007AFF;
    letter-spacing: 1.5px;
    text-align: center;
    line-height: 1.52rem;
    display: block;
  }
  .getMroe .popover .bottom{
    background: rgba(255,255,255,1);
    border-radius: 0.373rem;
    height: 1.493rem;
    width: 100%;
    overflow: hidden;
  }
  .getMroe .popover .bottom a{
    width: 100%;
    height: 1.52rem;
    font-family: PingFangSC-Medium;
    font-size: 0.533rem;
    color: #007AFF;
    letter-spacing: 1.5px;
    text-align: center;
    line-height: 1.52rem;
    display: block;
  }
  .successTip{
    opacity: 0.8;
    background: #000000;
    border-radius: 0.267rem;
    position: fixed;
    top: 7.147rem;
    left: 50%;
    transform: translateX(-50%);
    height: 2.66667rem;
    width: 5.333rem;
    font-family: PingFangSC-Regular;
    font-size: 0.427rem;
    color: #FFFFFF;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1000
  }
  .shareTip{
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 10000;
    background-color: rgba(0,0,0,0.6);
    top: 0px;
    left: 0px;
    background-image: url("/static/sharetip.png");
    background-position: right top;
    background-repeat: no-repeat;
    background-size: 4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue